<template>
	<div id="ag-grid-demo">
		<vx-card id="grid-loader" class="vs-con-loading__container">
			<ag-grid-vue
				:gridOptions="gridOptions"
				class="ag-theme-material w-100 mb-4 ag-grid-table"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowData="tableData"
				rowSelection="multiple"
				:enableRangeSelection="true"
				:suppressCopyRowsToClipboard="true"
				colResizeDefault="shift"
				:suppressDragLeaveHidesColumns="true"
				:animateRows="false"
				:floatingFilter="true"
				:pagination="true"
				:paginationPageSize="paginationPageSize"
				:suppressPaginationPanel="true"
				:suppressRowClickSelection="true"
				:rowClassRules="rowClassRules"
				:statusBar="statusBar"
				:sideBar="sideBar"
				:rowHeight="38"
				@filter-changed="onFilterChanged"
				@row-selected="onRowSelected"
				@column-resized="onColumnResized">
			</ag-grid-vue>
			<div class="vx-row">
				<div v-if="user_role == 'admin'" class="vx-col w-full md:w-1/2 flex justify-center md:justify-start">
					<template v-if="selectedNodes.length">
						<vs-button class="md:block" @click="createSourcePrompt()">Create/Edit Source</vs-button>
					</template>
				</div>
				<div class="vx-col w-full" :class="{ 'md:w-1/2': user_role == 'admin' }">
					<vs-pagination
					:total="totalPages"
					:max="maxPageNumbers"
					v-model="currentPage" />
				</div>
			</div>
		</vx-card>

		<!-- Create Rule -->
		<vs-prompt id="create-prompt" vs-title="Enter source name" :vs-is-valid="source['name'] != ''" @vs-cancel="source['name']=''" @vs-accept="createSource" :vs-active.sync="source['prompt']">
			<div class="con-exemple-prompt text-center">
				<vs-input v-model="source['name']" class="w-full mb-2"/>

				<div class="vx-col w-full">
					<vs-checkbox v-model="source['mask']" class="m-0">Mask as generic</vs-checkbox>
				</div>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
	import { AgGridVue } from "ag-grid-vue"
	import "ag-grid-enterprise";

	import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'

	export default {
		components: {
			AgGridVue,
		},
		data() {
			return {
				searchQuery: '',
				gridOptions: {},
				maxPageNumbers: 7,
				gridApi: null,
				defaultColDef: {
					sortable: true,
					resizable: true,
					suppressMenu: true,
					suppressMovable: false,
					filter: false,
					filterParams: {
						suppressAndOrCondition: true,
					},
				},
				rowClassRules: null,
				statusBar: null,
				sideBar: null,
				columnDefs: [
				{
					headerName: 'Email',
					field: 'email',
					minWidth: 350,
					filter: "agTextColumnFilter",
					pinned: 'left',
					checkboxSelection: JSON.parse(localStorage.getItem('userDetails')).role == 'admin',
				},
				{
					headerName: 'ID',
					field: 'id',
					filter: "agTextColumnFilter",
					minWidth: 150,
					hide: true,
				},
				{
					headerName: 'Level',
					field: 'level',
					filter: "agTextColumnFilter",
					minWidth: 150,
					cellRenderer: (data) => {
						if(data.value != null) {
							switch (data.value) {
								case 0:
									return `<div class="badge badge--danger inline">${data.value}</div>`
								case 1:
									return `<div class="badge badge--dark inline">${data.value}</div>`
								case 2:
									return `<div class="badge badge--warning inline">${data.value}</div>`
								case 3:
									return `<div class="badge badge--success inline">${data.value}</div>`
								default:
									return ''
							}
						}
						else {
							return ''
						}
					},
				},
				{
					headerName: 'Source Name',
					field: 'source_name',
					filter: "agTextColumnFilter",
					minWidth: 275,
				},
				{
					headerName: 'Masked',
					field: 'masked',
					filter: "agTextColumnFilter",
					minWidth: 150,
				},
				{
					headerName: 'Rule',
					field: 'rule',
					filter: "agTextColumnFilter",
					minWidth: 150,
				},
				{
					headerName: 'Active',
					field: 'active',
					filter: "agSetColumnFilter",
					filterParams: {
						suppressAndOrCondition: true,
						newRowsAction: 'keep',
						values: [1,0],
						suppressMiniFilter: true,
						cellRenderer: (data) => {
							if (parseInt(data.value) === 0) {
								return 'no';
							}
							else if (parseInt(data.value) === 1) {
								return 'yes';
							}
							else {
								return data.value;
							}
						}
					},
					cellRenderer: (data) => {
						if (data.value == null) {
							return ''
						}
						if(data.value) {
							return `<div class="badge badge--success inline">yes</div>`
						}
						else {
							return `<div class="badge badge--danger inline">no</div>`
						}
					},
					minWidth: 150,
				},
				{
					headerName: 'Name',
					field: 'name',
					filter: "agTextColumnFilter",
					minWidth: 275,
				},
				{
					headerName: 'Email Domain',
					field: 'email_domain',
					filter: "agTextColumnFilter",
					minWidth: 275,
				},
				{
					headerName: 'Source ID',
					field: 'source_id',
					filter: "agTextColumnFilter",
					minWidth: 150,
					hide: true,
				},
				{
					headerName: 'Domains',
					field: 'domains',
					filter: "agTextColumnFilter",
					minWidth: 150,
				},
				{
					headerName: 'Suspensions',
					field: 'suspensions',
					filter: "agTextColumnFilter",
					minWidth: 150,
				},
				{
					headerName: 'Unsuspensions',
					field: 'unsuspensions',
					filter: "agTextColumnFilter",
					minWidth: 150,
				},
				{
					headerName: 'Percentage',
					field: 'percentage',
					filter: "agTextColumnFilter",
					minWidth: 150,
					cellRenderer: (data) => {
						if(data.value != null) {
							return `${data.value}%`
						}
						else {
							return ''
						}
					},
				},
				{
					headerName: 'Created At',
					field: 'created_at',
					filter: 'agMultiColumnFilter',
					filterParams: {
						filters: [
							{
								filter: 'agTextColumnFilter',
								filterParams: {
									suppressAndOrCondition: true,
									newRowsAction: 'keep',
								}
							},
							{
								filter: 'agDateColumnFilter',
								filterParams: {
									suppressAndOrCondition: true,
									defaultOption: 'inRange',
									newRowsAction: 'keep',
									comparator: function(filterLocalDateAtMidnight, cellValue) {
										if (cellValue === null) return -1;

										let cellDate = new Date(cellValue);
										
										let cellDateString = new Date(cellDate.toDateString());
										let filterLocalDateAtMidnightString = new Date(filterLocalDateAtMidnight.toDateString());
										
										if (cellDateString.getTime() === filterLocalDateAtMidnightString.getTime()) {
											return 0;
										}
										if (cellDate < filterLocalDateAtMidnight) {
											return -1;
										}
										if (cellDate > filterLocalDateAtMidnight) {
											return 1;
										}
									},
								}
							},
						],
					},
					minWidth: 235,
					cellRenderer: (data) => {
						if(data.value) {
							return this.$moment.utc(data.value).format('DD-MM-YYYY HH:mm:ss')
						}
						else {
							return ''
						}
					},
					sort: 'desc',
				},
				{
					headerName: 'Updated At',
					field: 'updated_at',
					filter: 'agMultiColumnFilter',
					filterParams: {
						filters: [
							{
								filter: 'agTextColumnFilter',
								filterParams: {
									suppressAndOrCondition: true,
									newRowsAction: 'keep',
								}
							},
							{
								filter: 'agDateColumnFilter',
								filterParams: {
									suppressAndOrCondition: true,
									defaultOption: 'inRange',
									newRowsAction: 'keep',
									comparator: function(filterLocalDateAtMidnight, cellValue) {
										if (cellValue === null) return -1;

										let cellDate = new Date(cellValue);
										
										let cellDateString = new Date(cellDate.toDateString());
										let filterLocalDateAtMidnightString = new Date(filterLocalDateAtMidnight.toDateString());
										
										if (cellDateString.getTime() === filterLocalDateAtMidnightString.getTime()) {
											return 0;
										}
										if (cellDate < filterLocalDateAtMidnight) {
											return -1;
										}
										if (cellDate > filterLocalDateAtMidnight) {
											return 1;
										}
									},
								}
							},
						],
					},
					minWidth: 235,
					cellRenderer: (data) => {
						if(data.value) {
							return this.$moment.utc(data.value).format('DD-MM-YYYY HH:mm:ss')
						}
						else {
							return ''
						}
					}
				},
				],
				tableData: null,
				source: {
					name: '',
					prompt: false,
					mask: false
				},
				selectedNodes: [],
			}
		},
		watch: {
			windowWidth(val) {
				// Toggle colummn movable
				this.toggleColumnMovable(val);
				// Toggle colummn pinning
				this.toggleColumnPinned(val);
			},
			dateRangeValue: {
                handler: function(val) {
					if (val['column'] != '' && val['startDate'] != null && val['endDate'] != null) {
						// Show loader
						this.showDivLoading();
						
						// Table Data AXIOS Call
						this.filterTableDataByDateRange(val);

						// Set filter active flag
						this.$store.dispatch("setDateRangeActive");
					}
					else {
						// Show loader
						this.showDivLoading();
						
						// Table Data AXIOS Call
						this.populateTableData('loader');
					}
                },
                deep: true
            },
		},
		computed: {
			windowWidth: function(){
				return this.$store.state.windowWidth;
			},
			paginationPageSize() {
				if(this.gridApi) {
					return this.gridApi.paginationGetPageSize()
				}
				else {
					return 500
				}
			},
			totalPages() {
				if(this.gridApi) {
					return this.gridApi.paginationGetTotalPages()
				}
				else {
					return 0
				}
			},
			currentPage: {
				get() {
					if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
						else return 1
					},
				set(val) {
					this.gridApi.paginationGoToPage(val - 1);
				}
			},
			dateRangeValue() {
				return this.$store.getters.getDateRangeValue;
			},
			user_role() {
				return JSON.parse(localStorage.getItem('userDetails')).role;
			},
		},
		methods: {
			showDivLoading(){
				this.$vs.loading({
					container: '#grid-loader',
					scale: 0.45
				});
			},
			hideDivLoading(){
				this.$vs.loading.close("#grid-loader > .con-vs-loading");
			},
			toggleColumnMovable(val) {
				if(val <= 576) {
					this.defaultColDef['suppressMovable'] = true;
				}
				else {
					this.defaultColDef['suppressMovable'] = false;
				}
			},
			toggleColumnPinned(val) {
				if(val <= 576) {
					this.maxPageNumbers = 4;
					this.gridOptions.columnApi.setColumnPinned('email', null);
				}
				else {
					this.gridOptions.columnApi.setColumnPinned('email', 'left')
				}
			},
			onColumnResized() {
				this.gridApi.resetRowHeights();
			},
			updateSearchQuery(val) {
				this.gridApi.setQuickFilter(val);
			},
			sizeColumnsToFit() {
				this.gridApi.sizeColumnsToFit();
			},
			onRowSelected(event) {
				if(event.node.selected) {
					// Push to selectedNodes
					this.pushToArray(this.selectedNodes, event.node.data, 'id');
				}
				else {
					// Remove from selectedNodes
					this.removeFromArray(this.selectedNodes, event.node.data, 'id');
				}
			},
			onFilterChanged() {
				// Set Listing Filtered Count
				this.$store.dispatch("setListingFilteredCount", this.gridApi.getDisplayedRowCount());
			},
			createSourcePrompt() {
				this.source['name'] = '';
				this.source['prompt'] = true;
			},
			createSource() {
				let self = this,
					nodes = self.selectedNodes.map(x => {
								return {
									id: x['id'],
									email: x['email']
								};
							});

				// Show loader
				this.showDivLoading();
				// Post Axios Call
				this.$axiosSecure.post('/trusted-source-create', {
					'source-name' : this.source['name'],
					'node': nodes,
					'mask': this.source['mask'] ? 1 : 0,
					watchtower_email: JSON.parse(localStorage.getItem('userDetails')).email
				})
				.then(() => {
					// Confimation notification
					self.$vs.notify({
						color: 'success',
						title: 'Source creation success',
						text: 'The trusted source has been created'
					});

					// Close Prompt
					this.source['prompt'] = false;
					// Reset selection
					this.gridApi.deselectAll();
					// Table Data AXIOS Call
					this.populateTableData('loader');
				})
				.catch((error) => {
					// Hide loader
					this.hideDivLoading();
					// Error notification
					self.$vs.notify({
						color: 'danger',
						title: 'Something went wrong',
						text: 'Please contact the server admin'
					});

					console.log(error);
				});
			},
			populateTableData(loader) {
				let self = this;

				this.$axiosSecure.get('/get-request-sources')
				.then((response) => {
					this.tableData = response.data;

					// Set Listing Count
					this.$store.dispatch("setListingTotalCount", response.data.length);
					// Set Listing Filtered Count
					this.$store.dispatch("setListingFilteredCount", response.data.length);
				
					if(loader == 'loader') {
						// Hide loader
						this.hideDivLoading();
					}
				})
				.catch((error) => {
					// Error notification
					self.$vs.notify({
						color: 'danger',
						title: 'Something went wrong',
						text: 'Please contact the server admin'
					});

					console.log(error);
				});
			},
			filterTableDataByDateRange(obj) {
				let self = this;

				this.$axiosSecure.get('/get-request-sources', {
					params: {
						column: obj['column']['value'],
						startDate: self.$moment.utc(obj['startDate']).local().format('DD-MM-YYYY'),
						endDate: self.$moment.utc(obj['endDate']).local().format('DD-MM-YYYY')
					}
				})
				.then((response) => {
					this.tableData = response.data;

					// Set Listing Count
					this.$store.dispatch("setListingTotalCount", response.data.length);
					// Set Listing Filtered Count
					this.$store.dispatch("setListingFilteredCount", response.data.length);
				
					// Hide loader
					this.hideDivLoading();
				})
				.catch((error) => {
					// Error notification
					self.$vs.notify({
						color: 'danger',
						title: 'Something went wrong',
						text: 'Please contact the server admin'
					});

					console.log(error);
				});
			},
			populateDateRangeFilterColumns() {
				this.$store.dispatch("setDateRangeColumns", [
					{
						label: 'Created At',
						value: 'created_at'
					},
					{
						label: 'Updated At',
						value: 'updated_at'
					}
				]);
			},
		},
		beforeMount() {
			// Table Data AXIOS Call
			this.populateTableData();

			// Reset movable columns on mobile
			this.toggleColumnMovable(this.windowWidth);

			// Set Grid sidebar
			this.sideBar = {
				toolPanels: [
				{
					id: "columns",
					labelDefault: "Columns",
					labelKey: "columns",
					iconKey: "columns",
					toolPanel: "agColumnsToolPanel",
					toolPanelParams: {
						suppressRowGroups: true,
						suppressValues: true,
						suppressPivots: true,
						suppressPivotMode: true,
						suppressSideButtons: true,
						suppressColumnSelectAll: true,
						suppressColumnExpandAll: true
					}
				}
				],
			};
		},
		mounted() {
			this.gridApi = this.gridOptions.api;

			// Resize to fit columns
			this.sizeColumnsToFit();

			// Populate DateRangeFilter Columns
			this.populateDateRangeFilterColumns();

			// Reset pinned columns on mobile
			this.toggleColumnPinned(this.windowWidth);

			// Page Refresh Event
			this.$root.$on('refreshPage', () => {
				// Reset filters
				this.gridApi.setFilterModel(null);
				// Reset selection
				this.gridApi.deselectAll();
				// Reset sort
				this.gridApi.setSortModel([
					{
					colId: "created_at",
					sort: "desc"
					}
				]);
				// Table Data AXIOS Call
				this.populateTableData();
			});

			// Page Download Event
			this.$root.$on('downloadPage', () => {
				// AgGrid CSV Export
				this.gridApi.exportDataAsCsv()
			});
		},
		destroyed() {
			// Clear Listing Count
			this.$store.dispatch("clearListingCount");

			// Clear DateRangeFilter
            this.$store.dispatch("clearDateRangeValue");
			this.$store.dispatch("clearDateRangeColumns");
			this.$store.dispatch("clearDateRangeActive");
			
			// Unbind Button Event Listeners
			this.$root.$off('refreshPage');
			this.$root.$off('downloadPage');
		}
	}

</script>